import { render, staticRenderFns } from "./ProductAccessRequired.vue?vue&type=template&id=7a5ce0a0&scoped=true"
import script from "./ProductAccessRequired.vue?vue&type=script&lang=js"
export * from "./ProductAccessRequired.vue?vue&type=script&lang=js"
import style0 from "./ProductAccessRequired.vue?vue&type=style&index=0&id=7a5ce0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ce0a0",
  null
  
)

export default component.exports